import React from 'react'

const NotFoundPage = () => {
  return (
    <div>
      <h1>NotFoundPage</h1>
    </div>
  )
}

export default NotFoundPage
